import { cn } from "@/utils";
import type { LegalSection } from "../content/types";

type LegalTocListProps = {
  sections: LegalSection[];
  activeId: string;
};

const linkClass = (isActive: boolean) =>
  cn(
    "text-ds-small focus-visible:ring-ds-focus -ml-px flex min-h-11 cursor-pointer items-center gap-3 border-l-2 py-1 pl-4 transition-colors duration-150 focus-visible:ring-2 focus-visible:outline-none motion-reduce:transition-none",
    isActive
      ? "border-ds-brand-600 text-ds-ink-900 font-semibold"
      : "text-ds-ink-600 hover:text-ds-ink-900 hover:border-ds-border-strong border-transparent"
  );

/** Os itens do índice, numerados como as seções. */
export const LegalTocList = ({ sections, activeId }: LegalTocListProps) => (
  <ol className="border-ds-border flex flex-col border-l">
    {sections.map((section, index) => (
      <li key={section.id}>
        <a
          href={`#${section.id}`}
          aria-label={section.title}
          aria-current={section.id === activeId ? "location" : undefined}
          className={linkClass(section.id === activeId)}
        >
          <span aria-hidden="true" className="ds-numeric text-ds-caption">
            {String(index + 1).padStart(2, "0")}
          </span>
          {section.title}
        </a>
      </li>
    ))}
  </ol>
);
